import { showSuccess } from '@calendly/alert'
import { I18n } from '@calendly/i18n'

import { rootApi } from 'root-api'

import { createUrl } from '../shared/create_url'

const api = rootApi.enhanceEndpoints({ addTagTypes: ['SINGLE-USE-LINKS', 'SINGLE-USE-LINKS-PARTIAL-LIST'] }).injectEndpoints({
  endpoints: (build) => ({
    fetchSingleUseLinkData: build.query({
      query: ({ scopeId, scopeType, queryParams }) => ({
        url: createUrl('single_use_links', scopeType, scopeId),
        params: {
          ...queryParams
        }
      }),
      forceRefetch: ({ currentArg, previousArg }) => (
        currentArg?.scopeId !== previousArg?.scopeId
        || currentArg?.scopeType !== previousArg?.scopeType
        || currentArg?.queryParams !== previousArg?.queryParams
      ),
      providesTags: (result) => (result?.results
        ? [...result.results.map(({ id }) => ({ type: 'SINGLE-USE-LINKS', id })),
          { type: 'SINGLE-USE-LINKS', id: 'SINGLE-USE-LINKS-PARTIAL-LIST' }]
        : [{ type: 'SINGLE-USE-LINKS', id: 'SINGLE-USE-LINKS-PARTIAL-LIST' }])
    }),
    batchDeleteSingleUseLinks: build.mutation({
      query: ({ singleUseLinkIds }) => ({
        url: createUrl('single_use_links'),
        method: 'DELETE',
        params: {
          ids: singleUseLinkIds
        }
      }),
      invalidatesTags: (_1, _2, { singleUseLinkIds }) => [
        { type: 'SINGLE-USE-LINKS', id: 'SINGLE-USE-LINKS-PARTIAL-LIST' },
        'EMPTY_STATES_ACTIVATION_DATA'
      ],
      onQueryStarted: async ({ singleUseLinkIds, name, onSuccess }, { dispatch, queryFulfilled }) => {
        await queryFulfilled

        dispatch(showSuccess(
          I18n.t('publisher.scheduling.single_use_links.flash.delete_success', { name, count: singleUseLinkIds.length })
        ))

        if (onSuccess) { onSuccess() }
      }
    })
  }),
  overrideExisting: true
})

export const {
  useFetchSingleUseLinkDataQuery,
  useBatchDeleteSingleUseLinksMutation
} = api
